<template>
  <div class='flex w-full flex-col'>
    <CodeField
      class='flex w-full flex-col'
      :model-value='stringifiedValue'
      :value='stringifiedValue'
      :label='label'
      :name='name'
      :edit-mode='editMode'
      :disabled='disabled'
      :style='{ ...style, height: style.height ? style.height : "150px" }'
      :field='field'
      :lang='lang'
      :help='help'
      :mode='mode'
      :error='errors'
      @update:model-value='onUpdate($event)'
    />
  </div>
</template>

<script lang="ts">
  import { defineComponent, onMounted, ref, watch } from 'vue'
  import CodeField from '../code-field/CodeField.vue'
  import useInputFieldBase, { InputFieldProps } from '../../../compositions/useInputFieldBase'
  import { InputFieldHasHelpProps } from '@/compositions/useInputFieldHasHelp'

  export default defineComponent({
    name: 'JsonField',
    components: {
      CodeField,
    },
    props: {
      ...InputFieldProps,
      ...InputFieldHasHelpProps,
      style: {
        type: Object,
        default() {
          return {
            height: '150px',
          }
        },
      },
      lang: {
        type: String,
        default: 'json',
      },
      mode: {
        type: String,
        default: 'json',
      },
    },
    emits: ['has-error'],
    setup(props, { emit }) {
      const { updateValue } = useInputFieldBase()

      const stringifiedValue = ref('')
      const errors = ref([])

      const onUpdate = (newValue: string) => {
        try {
          updateValue(JSON.parse(newValue))
          errors.value = ([])
          emit('has-error', false)
        } catch(e) {
          errors.value = ([e])
          emit('has-error', true)
        }
      }

      watch(() => props.modelValue, (newValue) => {
        try {
          stringifiedValue.value = JSON.stringify(newValue, undefined, 4)
        } catch(e) {
          errors.value = ([e])
        }
      }, {
        deep: true, 
      })

      onMounted(() => {
        try {
          stringifiedValue.value = JSON.stringify(props.modelValue, undefined, 4)
        } catch(e) {
          errors.value = ([e])
        }
      })

      return {
        onUpdate,
        stringifiedValue,
        errors,
      }
    },
  })
</script>
